import _regeneratorRuntime from "/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/node/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

function e(e) {
  var t = "==".slice(0, (4 - e.length % 4) % 4),
      n = e.replace(/-/g, "+").replace(/_/g, "/") + t,
      r = atob(n),
      o = new ArrayBuffer(r.length),
      c = new Uint8Array(o);

  for (var _e = 0; _e < r.length; _e++) {
    c[_e] = r.charCodeAt(_e);
  }

  return o;
}

function t(e) {
  var t = new Uint8Array(e);
  var n = "";

  var _iterator = _createForOfIteratorHelper(t),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e2 = _step.value;
      n += String.fromCharCode(_e2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

function n(e, t, r) {
  if ("copy" === t) return r;
  if ("convert" === t) return e(r);
  if (t instanceof Array) return r.map(function (r) {
    return n(e, t[0], r);
  });

  if (t instanceof Object) {
    var _o = {};

    for (var _i = 0, _Object$entries = Object.entries(t); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          _c = _Object$entries$_i[0],
          _i2 = _Object$entries$_i[1];

      if (_c in r) null != r[_c] ? _o[_c] = n(e, _i2.schema, r[_c]) : _o[_c] = null;else if (_i2.required) throw new Error("Missing key: " + _c);
    }

    return _o;
  }
}

function r(e) {
  return {
    required: !0,
    schema: e
  };
}

function o(e) {
  return {
    required: !1,
    schema: e
  };
}

var c = {
  type: r("copy"),
  id: r("convert"),
  transports: o("copy")
},
    i = {
  appid: o("copy"),
  appidExclude: o("copy"),
  credProps: o("copy")
},
    a = {
  appid: o("copy"),
  appidExclude: o("copy"),
  credProps: o("copy")
},
    s = {
  publicKey: r({
    rp: r("copy"),
    user: r({
      id: r("convert"),
      name: r("copy"),
      displayName: r("copy")
    }),
    challenge: r("convert"),
    pubKeyCredParams: r("copy"),
    timeout: o("copy"),
    excludeCredentials: o([c]),
    authenticatorSelection: o("copy"),
    attestation: o("copy"),
    extensions: o(i)
  }),
  signal: o("copy")
},
    p = {
  type: r("copy"),
  id: r("copy"),
  rawId: r("convert"),
  response: r({
    clientDataJSON: r("convert"),
    attestationObject: r("convert")
  }),
  clientExtensionResults: r(a)
},
    l = {
  mediation: o("copy"),
  publicKey: r({
    challenge: r("convert"),
    timeout: o("copy"),
    rpId: o("copy"),
    allowCredentials: o([c]),
    userVerification: o("copy"),
    extensions: o(i)
  }),
  signal: o("copy")
},
    u = {
  type: r("copy"),
  id: r("copy"),
  rawId: r("convert"),
  response: r({
    clientDataJSON: r("convert"),
    authenticatorData: r("convert"),
    signature: r("convert"),
    userHandle: r("convert")
  }),
  clientExtensionResults: r(a)
};
export var schema = {
  credentialCreationOptions: s,
  publicKeyCredentialWithAttestation: p,
  credentialRequestOptions: l,
  publicKeyCredentialWithAssertion: u
};
export function create(_x) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(r) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = function (e) {
              var r = e;
              return r.clientExtensionResults = e.getClientExtensionResults(), n(t, p, r);
            };

            _context.next = 3;
            return navigator.credentials.create(function (t) {
              return n(e, s, t);
            }(r));

          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _create.apply(this, arguments);
}

export function get(_x2) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(r) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = function (e) {
              var r = e;
              return r.clientExtensionResults = e.getClientExtensionResults(), n(t, u, r);
            };

            _context2.next = 3;
            return navigator.credentials.get(function (t) {
              return n(e, l, t);
            }(r));

          case 3:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _get.apply(this, arguments);
}

export function supported() {
  return !!(navigator.credentials && navigator.credentials.create && navigator.credentials.get && window.PublicKeyCredential);
}